import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { Location } from '@angular/common'
import { OmsService } from '../../services/oms.service';
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { OrdersService } from '../../services/orders.service';
import { Order } from '../../classes/orders';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as XLSX from 'xlsx';
import * as jQuery from 'jquery';
import { DashboardService } from 'app/services/dashboard.service';
import { concat, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

@Component({
	selector: 'app-orders-dashboard',
	templateUrl: './orders-dashboard.component.html',
	styleUrls: ['./orders-dashboard.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		])
	]
})
export class OrdersDashboardComponent implements OnInit {

	picking: any = [];
	adrs: any = [];
	flip = 'inactive';
	header: any;
	results: any;
	fliptitle: any;
	billable: any;
	viewing_title = '';
	viewing_data: any = false;
	picklateone = [];
	picklatetwo = [];
	picklatethree = [];

	notfillableone = [];
	notfillabletwo = [];
	notfillablethree = [];
	credits: any = [];

	allorders;
	allone = [];
	alltwo = [];
	allthree = [];
	returns = [];
	refused: any = [];
	notready: any;
	status: any;
	carddata: any;
	data: any;
	ready: any;


	fileName;
	public type: string;
	public error;
	color: any = 'blue'
	config: any = [];

	quotes: any = [];
	overdues: any = [];
	overdue1: any = [];
	overdue2: any = [];
	overdue3: any = [];

	overdues_length: any;
	overdue1_length: any;
	overdue2_length: any;
	overdue3_length: any;
	flipdata: boolean | unknown[];

	constructor(private dashboardService: DashboardService, private route: ActivatedRoute, private globalSearchService: GlobalSearchService, private ordersService: OrdersService, private omsService: OmsService, public cdr: ChangeDetectorRef, private location: Location, public router: Router, private formBuilder: UntypedFormBuilder) {
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

	}



	ngOnInit(): void {
		this.error = '';

		const token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
		if (token) {
			this.omsService.setupSocketConnection(token);
			this.omsService.subscribeToCards((err, data) => {
				if (data) {
					this.loadData()
				}
			});
		}



		this.route.params.subscribe(params => {
			if (params['type']) {
				this.toggleFlip(params['type'], 'inactive')
			}
		});


		this.loadData()
	}

	randomString(length, chars) {
		let result = '';
		for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
		return result;
	}

	consolidatePicks(input: any) {
		const orders = [];
		return input.map((ord) => {
			if (ord.ORDER_NUMBER && ord.DATE_ORDERED && !orders.includes(ord.ORDER_NUMBER) && ord.CUST_NAME) {
				orders.push(ord.ORDER_NUMBER)
				return ord;
			}
		}).filter((res) => res != undefined)
	}

	pickLoading: any = false;
	loadData() {

		const LATE_FILTER_CONFIG = {
			allone: { fromdays: 5, todays: 3 },
			alltwo: { fromdays: 7, todays: 5 },
			allthree: { fromdays: 9999, todays: 7 },
			billable: { fromdays: 5, todays: 3 },
			notfillableone: { fromdays: 5, todays: 3 },
			notfillabletwo: { fromdays: 7, todays: 5 },
			notfillablethree: { fromdays: 9999, todays: 7 },
			picklateone: { fromdays: 5, todays: 3 },
			picklatetwo: { fromdays: 7, todays: 5 },
			picklatethree: { fromdays: 90, todays: 7 }, // Forced
		};


		concat(
		  this.ordersService.getPicking().pipe(tap(results => {
				this.picking = results;
				this.globalSearchService.pickingOrderData.next(results);
		  })),
		  this.ordersService.getRefused().pipe(tap(results => {
				this.refused = results;
		  })),
		  this.ordersService.getADRSCount().pipe(tap(results => {
				this.adrs = results;
		  })),
		  this.ordersService.getOpenQuotes().pipe(tap(results => {
				this.quotes = results;
		  }))
		).subscribe();

		this.pickLoading = true;
		this.globalSearchService.pickingOrderData.subscribe((results: any) => {
			this.picking = results;
			this.pickLoading = false;
			if (this.picking) {
				this.credits = results.opencredits;
				this.allorders = this.consolidatePicks([...this.picking.notfillable, ...this.picking.fillable, ...this.picking.partialpicked, ...this.picking.picked]);
				this.picking.partialpicked = this.consolidatePicks(this.picking.partialpicked);
				this.picking.notfillable = this.consolidatePicks(this.picking.notfillable);

				this.picking.totalcount = this.allorders.length;
				this.picking.notfillablecount = this.picking.notfillable.length;

				const c = LATE_FILTER_CONFIG;

				this.allone = this.getFilteredLates(this.allorders, c.allone.fromdays, c.allone.todays);
				this.alltwo = this.getFilteredLates(this.allorders, c.alltwo.fromdays, c.alltwo.todays);
				this.allthree = this.getFilteredLates(this.allorders, c.allthree.fromdays, c.allthree.todays);

				this.billable = this.getFilteredLates(this.picking.billable, c.billable.fromdays, c.billable.todays);

				this.notfillableone = this.getFilteredLates(this.picking.notfillable, c.notfillableone.fromdays, c.notfillableone.todays);
				this.notfillabletwo = this.getFilteredLates(this.picking.notfillable, c.notfillabletwo.fromdays, c.notfillabletwo.todays);
				this.notfillablethree = this.getFilteredLates(this.picking.notfillable, c.notfillablethree.fromdays, c.notfillablethree.todays);

				this.picklateone = this.getFilteredLates(this.picking.fillable, c.picklateone.fromdays, c.picklateone.todays);
				this.picklatetwo = this.getFilteredLates(this.picking.fillable, c.picklatetwo.fromdays, c.picklatetwo.todays);
				this.picklatethree = this.getFilteredLatesForced(this.picking.fillable, c.picklatethree.fromdays, c.picklatethree.todays);

				this.returns = this.getReturns(this.picking.fillable);


				this.overdues = this.getOverdues(this.allorders);
				this.overdue1 = this.getOverdues(this.allorders, 1, 5);
				this.overdue2 = this.getOverdues(this.allorders, 5, 10);
				this.overdue3 = this.getOverdues(this.allorders, 10, 9999);


			}
		});
	}

	getReturns(datalist: any) {

		const result = datalist.filter((item: any) => {
			return (item.PICK < 0);

		});

		return result;

	}

	getFilteredLatesForced(datalist, fromdays: number, todays: number) {

		const result = datalist.filter((item: any) => {

			const subject = new Date(item.DATE_ORDERED);
			subject.setDate(subject.getDate());

			const before = new Date('1999-01-01');
			before.setDate(before.getDate());

			const until = new Date();
			until.setDate(until.getDate() - todays);
			return (subject >= before && subject <= until);

		});

		return result;

	}

	getFilteredLates(datalist, fromdays: number, todays: number) {

		const result = datalist.filter((item: any) => {
			const subject = new Date(item.DATE_ORDERED);

			subject.setDate(subject.getDate());

			const before = new Date();
			before.setDate(before.getDate() - fromdays);

			const until = new Date();
			until.setDate(until.getDate() - todays);

			return (subject >= before && subject <= until);

		});

		return result;

	}


	get totalNotFillableUnique(): number {
	  const set = new Set([
			...(this.notfillableone || []).map(o => o.ORDER_NUMBER),
			...(this.notfillabletwo || []).map(o => o.ORDER_NUMBER),
			...(this.notfillablethree || []).map(o => o.ORDER_NUMBER)
	  ]);
	  return set.size;
	}


	getOverdues(datalist: any[], fromdays?: number, todays?: number) {
		const now = new Date();
		now.setHours(0, 0, 0, 0); // truncate time

		const result = datalist.filter((item: any) => {
			const rawDate = item.DATE_WANTED || item.DATE_ORDERED;
			if (!rawDate) {return false;}

			const wanted = new Date(rawDate);
			wanted.setHours(0, 0, 0, 0); // truncate time

			const daysOverdue = Math.ceil((now.getTime() - wanted.getTime()) / (1000 * 3600 * 24));

			if (daysOverdue <= 0) {return false;}

			if (typeof fromdays === 'number' && typeof todays === 'number') {
				return daysOverdue >= fromdays && daysOverdue <= todays;
			}

			// fallback: all overdue
			return daysOverdue >= 1;
		});

		const countUnique = new Set(result.map(i => i.ORDER_NUMBER)).size;

		switch (todays) {
		case 5:
			this.overdue1_length = countUnique;
			break;
		case 10:
			this.overdue2_length = countUnique;
			break;
		case 9999:
			this.overdue3_length = countUnique;
			break;
		default:
			this.overdues_length = countUnique;
			break;
		}

		const sorted = result.sort((a, b) => {
			const aDate = new Date(a.DATE_WANTED || a.DATE_ORDERED);
			const bDate = new Date(b.DATE_WANTED || b.DATE_ORDERED);
			return aDate.getTime() - bDate.getTime();
		});

		return sorted;
	}


	addDays(date: Date, days: number): Date {
		date.setDate(date.getDate() + days);
		return date;
	}

	getHeader() {
		return this.header
	}

	getData() {
		return this.results
	}

	toggleFlipTest(viewing: any) {

		this.viewing_data = viewing.data
		this.viewing_title = viewing.title
		//this.flip = (this.flip == 'active') ? 'inactive':'active';
	}

	getOrderNumbers(input: any) {
		return [...new Set(input.map((ord: any) => {
			if (ord.ORDER_NUMBER) {
				return ord.ORDER_NUMBER
			}
		}))].filter(i => i !== undefined);
	}


	toggleFlip(dataset, setvalue, forcedata = false, list = []) {
		if (setvalue != '') {
			this.flip = setvalue;
		}
		///this is a bad idea. needs fixed
		switch (dataset) {
		case 'na':
			break;
		case 'refused':
			this.fliptitle = 'Refused Delivery';
			this.data = this.refused
			break;
		case 'quotes':
			this.fliptitle = 'Open Quotes';
			this.data = this.quotes
			break;
		case 'billable':
			this.fliptitle = 'Needs Invoices';

			this.data = this.picking.billable
			this.type = 'billable';
			break;
		case 'inpick':
			this.fliptitle = 'In Route Builder';
			this.data = this.picking.inpick
			this.type = 'inpick';
			break;
		case 'snoozed':
			this.fliptitle = 'Snoozed';
			this.type = 'snoozed';
			this.data = this.picking.snoozed
			break;
		case 'returns':
			this.fliptitle = 'Return to Bin';
			this.type = 'returns';
			this.data = this.returns
			this.flipdata = false;

			break;
		case 'notfillablethree':
			this.fliptitle = '7+ Not Fillable Orders';
			this.type = 'notfillablethree';
			this.data = this.notfillablethree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notfillabletwo':
			this.fliptitle = '5-7 Not Fillable Orders';
			this.type = 'notfillabletwo';
			this.data = this.notfillabletwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notfillableone':
			this.fliptitle = '3+ Not Fillable Orders';
			this.type = 'notfillableone';
			this.data = this.notfillableone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'allthree':
			this.fliptitle = 'All 7+ Orders';
			this.type = 'allthree';
			this.data = this.allthree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'alltwo':
			this.fliptitle = 'All 5-7 Orders';
			this.type = 'alltwo';
			this.data = this.alltwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'allone':
			this.fliptitle = 'All 3-5 Orders';
			this.type = 'allone';
			this.data = this.allone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'late':
			this.fliptitle = '7+ Late Orders';
			this.type = 'late';
			this.data = this.picklatethree;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'adrs':
			this.router.navigateByUrl('orders/adrs');
			break;
		case 'lateone':
			this.fliptitle = '3-5 Orders';
			this.type = 'latetwo';
			this.data = this.picklateone;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'latetwo':
			this.fliptitle = '5-7 Orders';
			this.type = 'latetwo';
			this.data = this.picklatetwo;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'partialpicked':
			this.fliptitle = 'Parital Picks';
			this.type = 'partialpicked';
			this.data = this.picking.partialpicked;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'dispatched':
			this.fliptitle = 'Dispatched';
			this.type = 'dispatched';
			this.data = this.picking.dispatched;
			break;
		case 'picked':
			this.fliptitle = 'Picked Orders';
			this.type = 'picked';
			this.data = this.picking.picked;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'parital':
			this.fliptitle = 'Partially Fillable Orders';
			this.type = 'parital';
			this.data = this.picking.parital;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'notfillablecount':
			this.fliptitle = 'Non Fillable Orders';
			this.type = 'notfillablecount';
			this.data = this.picking.notfillable;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'fillable':
			this.fliptitle = 'Fillable Orders';
			this.type = 'fillable';
			this.data = this.picking.fillable;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;
			break;
		case 'credits':
			this.fliptitle = 'Open Credits';
			this.type = 'credits';
			this.data = this.credits;
			break;
		case 'openorders':
			this.fliptitle = 'Open Orders';
			this.type = 'openorders';
			this.data = [...this.picking.notfillable, ...this.picking.fillable, ...this.picking.partialpicked];
			this.flipdata = false;
			break;
		case 'overdues':
			this.fliptitle = 'All Overdue Orders';
			this.type = 'overdues';
			this.data = this.overdues;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue1':
			this.fliptitle = '1-5 Overdue Orders';
			this.type = 'overdue1';
			this.data = this.overdue1;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue2':
			this.fliptitle = '5-10 Overdue Orders';
			this.type = 'overdue2';
			this.data = this.overdue2;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		case 'overdue3':
			this.fliptitle = '>10 Overdue Orders';
			this.type = 'overdue3';
			this.data = this.overdue3;
			this.flipdata = this.data ? this.getOrderNumbers(this.data) : false;

			break;
		default:
			this.fliptitle = dataset;

			if (forcedata) {
				this.data = list;
			} else {
				this.data = this.picking[dataset];
			}

			this.type = 'late';

			break;
		}
		switch (this.flip) {
		case 'inactive':
			this.flip = 'active';
			this.parseData(this.data);
			//this.updateData();
			//this.focusInput();
			break;
		default:

			this.flip = 'inactive';
			break;
		}

	}

	selectItemLookup(event: any) {
		this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		//http://localhost:4200/#/orders/entry/107/00
	}

	invoiceOrder(event: any) {
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	parseData(listin) {
		const newheader = [];
		(Object.keys(Object.values(listin)[0])).forEach((keys: any, vals: any) => {
			if (keys) {
				if (keys != 'sort') {
					newheader.push({ title: keys, data: keys })
				}
			}
		});
		const newvalues = []
		listin.forEach((keys: any, vals: any) => {
			newvalues.push(keys);
		});



		this.header = newheader;
		this.results = newvalues;

	}

	back(): void {
		this.location.back()
	}

	focusInput() {

	}

	exportExcel(): void {
		/* table id is passed over here */
		const element = document.getElementById('excel-table');
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

		/* generate workbook and add the worksheet */
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		XLSX.writeFile(wb, this.fileName);

	}
}